// src/constants.ts
var SUPPORTED_LOCALES = ["pt-br", "en", "es"];
var DEFAULT_LOCALE = "pt-br";
var LOCALE_COOKIE_NAME = "tessel-locale";
var LEGACY_LOCALE_COOKIE_NAME = "NEXT_LOCALE";
var LOCALE_NAMES = {
  "pt-br": "Portugu\xEAs",
  en: "English",
  es: "Espa\xF1ol"
};
var LOCALE_FLAGS = {
  "pt-br": "\u{1F1E7}\u{1F1F7}",
  en: "\u{1F1FA}\u{1F1F8}",
  es: "\u{1F1EA}\u{1F1F8}"
};
var isValidLocale = (value) => {
  return SUPPORTED_LOCALES.includes(value);
};
var LOCALE_HTML_LANG = {
  "pt-br": "pt-BR",
  en: "en",
  es: "es"
};

// src/cookie.ts
var readCookieValue = (cookieHeader, name) => {
  const parts = cookieHeader.split(";");
  for (const part of parts) {
    const [key, ...rest] = part.trim().split("=");
    if (key === name) {
      return decodeURIComponent(rest.join("="));
    }
  }
  return void 0;
};
var parseLocaleFromCookies = (cookieHeader, cookieName = LOCALE_COOKIE_NAME) => {
  if (!cookieHeader) {
    return null;
  }
  const primary = readCookieValue(cookieHeader, cookieName);
  if (primary && isValidLocale(primary)) {
    return primary;
  }
  const legacy = readCookieValue(cookieHeader, LEGACY_LOCALE_COOKIE_NAME);
  if (legacy && isValidLocale(legacy)) {
    return legacy;
  }
  return null;
};
var getLocaleFromCookie = (cookieName = LOCALE_COOKIE_NAME) => {
  if (typeof document === "undefined") {
    return DEFAULT_LOCALE;
  }
  return parseLocaleFromCookies(document.cookie, cookieName) ?? DEFAULT_LOCALE;
};
var setLocaleCookie = (locale, cookieName = LOCALE_COOKIE_NAME) => {
  if (typeof document === "undefined") {
    return;
  }
  const maxAge = 365 * 24 * 60 * 60;
  document.cookie = `${cookieName}=${locale}; path=/; max-age=${maxAge}; SameSite=Lax`;
};
export {
  DEFAULT_LOCALE,
  LEGACY_LOCALE_COOKIE_NAME,
  LOCALE_COOKIE_NAME,
  LOCALE_FLAGS,
  LOCALE_HTML_LANG,
  LOCALE_NAMES,
  SUPPORTED_LOCALES,
  getLocaleFromCookie,
  isValidLocale,
  parseLocaleFromCookies,
  setLocaleCookie
};
